export function resultTypeDisplayLabel(resultType) {
  return resultType === 'All' ? 'BAR + SCAR' : resultType;
}

export function achievedYearBucket(byYear, taxYear) {
  if (!byYear) return undefined;
  const y = parseInt(taxYear, 10);
  return byYear[y] ?? byYear[String(y)];
}

export function defaultResultTypeFromCards(cards, taxYear) {
  const scarFiled = achievedYearBucket(cards?.SCAR?.achieved_by_year, taxYear)?.totalCases ?? 0;
  return scarFiled > 0 ? 'SCAR' : 'All';
}

export function formatPortfolioReduction(ratio) {
  if (ratio == null) return '—';
  const absPct = (Math.abs(ratio) * 100).toFixed(1);
  return ratio >= 0 ? `-${absPct}%` : `+${absPct}%`;
}

function formatNumber(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  return Number.isNaN(n) ? String(value) : n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function formatWinsLine(wins, totalCases) {
  const w = wins ?? 0;
  const t = totalCases ?? 0;
  return t > 0 ? `Wins ${w}/${t}` : `Wins ${w}`;
}

export function formatWinRateLine(wins, totalCases) {
  if (totalCases == null || totalCases === 0) return 'Win rate —';
  const w = wins ?? 0;
  return `Win rate ${((100 * w) / totalCases).toFixed(0)}% (${w}/${totalCases})`;
}

export function avIfmvMetricLines(row) {
  return [
    `AV ${formatNumber(row?.totalAV)} → ${formatNumber(row?.totalDetermination)}`,
    `IFMV ${formatNumber(row?.totalIFMV)} → ${formatNumber(row?.totalDeterminationIFMV)}`,
  ];
}

export function municipalResultsPersistEntries(cards, taxYear) {
  const byYear = cards?.All?.achieved_by_year;
  if (!byYear) return [];
  const y = parseInt(taxYear, 10);
  return [y, y - 1, y - 2].flatMap((year) => {
    const bucket = byYear[year] ?? byYear[String(year)];
    if (!bucket) return [];
    return [{
      tax_year: year,
      total_cases: bucket.totalCases ?? 0,
      cases_resolved: bucket.resolvedCases ?? 0,
      total_starting_av: bucket.totalAV ?? 0,
      total_ending_av: bucket.totalDetermination ?? 0,
    }];
  });
}

export function contactsDiffer(offers, stips) {
  const normalize = (emails = []) => [...emails].map((e) => String(e).trim().toLowerCase()).filter(Boolean).sort();
  const a = normalize(offers?.emails);
  const b = normalize(stips?.emails);
  if (a.length !== b.length) return true;
  return a.some((email, i) => email !== b[i]);
}

export function formatContactLine(contact) {
  const emails = contact?.emails?.length ? contact.emails.join(', ') : null;
  return emails || 'None on file';
}

export function contactEmailSuggestions(contacts) {
  const all = [...(contacts?.offers?.emails ?? []), ...(contacts?.stips?.emails ?? [])];
  return [...new Set(all.filter(Boolean))];
}
